import { apiClient } from '../../../shared/api/axiosClient';

export interface DashboardMetricsResponse {
  activePots: number;
  grossValue: number;
  netValue: number;
  deductions: number;
  activeSites: number;
  workers: number;
}

export async function getDashboardMetrics(): Promise<DashboardMetricsResponse> {
  const response = await apiClient.get<DashboardMetricsResponse>(
    '/api/v1/dashboard/metrics'
  );
  return response.data;
}

export interface PotStatusSummaryDto {
  status: string;
  count: number;
  grossValue: number;
}

export interface GetPotStatusSummaryResponse {
  statuses: PotStatusSummaryDto[];
  totalCount: number;
}

export interface DashboardPeriodDto {
  year: number;
  weekNumber: number;
  periodStart: string;
  periodEnd: string;
}

export interface DashboardPeriodInfoResponse {
  periods: DashboardPeriodDto[];
}

export async function getDashboardPeriodInfo(): Promise<DashboardPeriodInfoResponse> {
  const response = await apiClient.get<DashboardPeriodInfoResponse>(
    '/api/v1/dashboard/period-info'
  );
  return response.data;
}

export async function getPotStatusSummary(): Promise<GetPotStatusSummaryResponse> {
  const response = await apiClient.get<GetPotStatusSummaryResponse>(
    '/api/v1/dashboard/status-summary'
  );
  return response.data;
}

export interface WeeklyAllocationDataPoint {
  year: number;
  weekNumber: number;
  label: string;
  booked: number;
  approved: number;
  rejected: number;
}

export interface WeeklyAllocationTrendResponse {
  weeks: WeeklyAllocationDataPoint[];
}

export async function getWeeklyAllocationTrend(): Promise<WeeklyAllocationTrendResponse> {
  const response = await apiClient.get<WeeklyAllocationTrendResponse>(
    '/api/v1/dashboard/weekly-allocation-trend'
  );
  return response.data;
}
